import React, { useState, useEffect } from 'react';
// Import images
import galleryImg1 from '../img/envision/mechanicalenginering/mechimg6.jpg';
import galleryImg2 from '../img/envision/dropdown/new/automo.png';
import galleryImgs31 from '../img/envision/dropdown/new/cmd.jpg';
import galleryImg41 from '../img/envision/dropdown/new/cmd.jpg';

const galleryImages = [galleryImg1, galleryImg2];
const galleryImagess = [galleryImgs31, galleryImg41];

const ManufacturingPafeData = () => {
    const [currentImage, setCurrentImage] = useState(galleryImages[0]);
    const [currentImages, setCurrentImages] = useState(galleryImagess[0]);

    // Function to cycle through images in galleryImages (first gallery)
    const changeFirstImage = () => {
        setCurrentImage((prevImage) => {
            const currentIndex = galleryImages.indexOf(prevImage);
            return galleryImages[(currentIndex + 1) % galleryImages.length];
        });
    };

    // Function to cycle through images in galleryImagess (second gallery)
    const changeSecondImage = () => {
        setCurrentImages((prevImage) => {
            const currentIndex = galleryImagess.indexOf(prevImage);
            return galleryImagess[(currentIndex + 1) % galleryImagess.length];
        });
    };

    // useEffect for cycling through galleryImages (first image set)
    useEffect(() => {
        const intervalId = setInterval(changeFirstImage, 3000); // Change image every 3 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    // useEffect for cycling through galleryImagess (second image set)
    useEffect(() => {
        const intervalId = setInterval(changeSecondImage, 4000); // Change image every 4 seconds
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    return (
        <section style={{ marginTop: '40px' }}>
            <div className="container">
                

                <div className="row">
                    <div className="col-md-6">
                        <div className="detailcontent">
                            <div
                                className="subheading title-datas"
                                style={{
                                    color: 'rgb(236 115 34)',
                                    fontSize: '28px',
                                    marginBottom: '41px',
                                    textAlign: 'center',
                                }}
                            >
                       Manufacturing
                             
                            </div>
                            <div className="textdetail">
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                At DREBCON, we empower the manufacturing sector by addressing critical challenges in cybersecurity and ensuring seamless compliance with global regulatory standards, enabling organizations to secure their operations and achieve scalable growth.
                                </p>
                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                Our expertise drives digital transformation by integrating advanced IT frameworks and safeguarding industrial systems, such as SCADA, ICS, and IIoT, from emerging cyber threats. By embedding robust governance models and intelligent risk management systems, we deliver sustainable value, ensuring operational efficiency, resilience, and innovation. 
                                 </p>

                                <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                                With a focus on secure, compliant, and interconnected manufacturing ecosystems, we enable organizations to thrive in a highly regulated and increasingly digitized global marketplace.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <img
                            src={galleryImg1} // Second gallery image
                            alt="gallery2"
                            className="imgbg-col"
                            style={{ maxWidth: '100%', padding: '15px', height: '85%', marginTop:'40px' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ManufacturingPafeData;
